import {SummaryModel} from '../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../common/entity/permissions.model';
import {ReportComponentDefinitionModel} from '../../../report-component-definition/api/entity/reportComponentDefinition.model';
import {UserSummary} from '../../../../account/modules/user/api/entity/userSummary.model';
import {AccountSummary} from '../../../../../shared/model/account/accountSummary.model';
import {OfficeSummaryModel} from "../../../../office/api/model/officeSummary.model";

export class ReportComponentSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    definition: ReportComponentDefinitionModel;
    label: string;
    account: AccountSummary;
    user: UserSummary;
    office: OfficeSummaryModel;
}

export const REPORT_COMPONENT_PERMISSION_PREVIEW = 'ACCOUNT_REPORT_COMPONENT_PERMISSION_ADD_PREVIEW';
